import './Sidebar.scss';

import * as React from 'react';
import propTypes from 'prop-types';
import Footer from './Footer';
import Header from './header/Header';
import Menu from './menu/Menu';

/**
 * Sidebar component
 * @module
 * @param {Menu} menu - Menu
 * @param {element} [Stats] - Stats element
 * @param {string} [type] - Type ('normal','compact','fullscreen')
 * @param {func} onClick - Function invoked on click
 * @param {func} onMenuSelect - Function invoked on menu select
 * @param {func} [onMenuFilter] - Function invoked on menu filter
 * @param {object} [sideBarToggleIcons] - Sidebar toggle icons
 * @param {element} brand - Brand component
 */
const Sidebar = (props) => {
  return (
    <div className="sidebar">
      <Header
        sidebarType={props.type}
        onClick={props.onClick}
        sideBarToggleIcons={props.sideBarToggleIcons}
        brand={props.brand}
      />
      <div className="main">
        <Menu
          onClick={props.onClick}
          onSelect={props.onMenuSelect}
          menu={props.menu}
          onMenuFilter={props.onMenuFilter}
          sidebarType={props.type}
        />
        {props.stats && React.cloneElement(props.stats, { sidebarType: props.type }, props.stats.children)}
      </div>
      <Footer compact={props.type === 'compact'} />
    </div>
  );
}

Sidebar.propTypes = {
  menu: propTypes.object.isRequired,
  stats: propTypes.element,
  type: propTypes.oneOf([
    'normal',
    'compact',
    'fullscreen',
  ]),
  onClick: propTypes.func.isRequired,
  onMenuSelect: propTypes.func.isRequired,
  onMenuFilter: propTypes.func,
  sideBarToggleIcons: propTypes.object,
  brand: propTypes.element
}

export default Sidebar;